import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { useOps } from '../../../hooks/useOps';
import { webhookService } from './webhook-service';

export const webhookQueryKeys = {
  all: ['api-webhook'] as const,
  detalhe: (ops: string) => [...webhookQueryKeys.all, ops] as const,
};

export function useWebhook() {
  const { currentOps } = useOps();

  return useQuery({
    queryKey: webhookQueryKeys.detalhe(currentOps || ''),
    queryFn: () => webhookService.obter(String(currentOps)),
    enabled: !!currentOps,
  });
}

// salvar / gerarSegredo / remover gravam a resposta no cache; testar não muda nada
export function useWebhookMutations() {
  const { currentOps } = useOps();
  const queryClient = useQueryClient();
  const ops = String(currentOps);
  const gravar = (webhook: unknown) =>
    queryClient.setQueryData(webhookQueryKeys.detalhe(ops), webhook ?? null);

  return {
    salvar: useMutation({
      mutationFn: (dados: { url: string; ativo: boolean }) => webhookService.salvar(ops, dados),
      onSuccess: gravar,
    }),
    gerarSegredo: useMutation({
      mutationFn: () => webhookService.gerarSegredo(ops),
      onSuccess: gravar,
    }),
    remover: useMutation({
      mutationFn: () => webhookService.remover(ops),
      onSuccess: () => gravar(null),
    }),
    testar: useMutation({
      mutationFn: () => webhookService.testar(ops),
    }),
  };
}
